import { render, staticRenderFns } from "./TeaserCardLinksToConsumers.vue?vue&type=template&id=dc59e168&scoped=true&"
import script from "./TeaserCardLinksToConsumers.vue?vue&type=script&lang=ts&"
export * from "./TeaserCardLinksToConsumers.vue?vue&type=script&lang=ts&"
import style0 from "./TeaserCardLinksToConsumers.vue?vue&type=style&index=0&id=dc59e168&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc59e168",
  null
  
)

export default component.exports